import { Injectable, defineInjectable, inject, Component, ViewChild, NgModule, Injector } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { TaskListComponent, FlowableModule } from 'flowable';
import { LoggerService, StaticInjectorService, AngularMaterialModule, UtilsModule, ConsoleLoggerService } from 'utils';
import { __extends, __assign } from 'tslib';
import { Router, ActivatedRoute, RouterModule } from '@angular/router';
import { MatTableDataSource, MatSort, MatSnackBar } from '@angular/material';
import { Breakpoints, BreakpointObserver } from '@angular/cdk/layout';
import { SidenavService, DialogService, SerendipityComponentsModule } from 'serendipity-components';
import { Subscription, of } from 'rxjs';
import { tap, delay } from 'rxjs/operators';
import { DynamicFormService, DynamicFormsModule } from 'dynamic-forms';
import { DashboardWidgetService } from 'dashboard-widgets';
import { MockDashboardService, DashboardModule } from 'dashboard';
import * as screenfull from 'screenfull';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { HttpClientInMemoryWebApiModule } from 'angular-in-memory-web-api';
import { AuthGuard } from 'auth';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ContactsService = /** @class */ (function () {
    function ContactsService(httpClient) {
        this.httpClient = httpClient;
        this.contactsUrl = 'api/contacts/';
    }
    /**
     * @return {?}
     */
    ContactsService.prototype.list = /**
     * @return {?}
     */
    function () {
        return this.httpClient.get(this.contactsUrl);
    };
    /**
     * @param {?} id
     * @return {?}
     */
    ContactsService.prototype.get = /**
     * @param {?} id
     * @return {?}
     */
    function (id) {
        return this.httpClient.get(this.contactsUrl + id);
    };
    ContactsService.decorators = [
        { type: Injectable, args: [{
                    providedIn: 'root'
                },] }
    ];
    /** @nocollapse */
    ContactsService.ctorParameters = function () { return [
        { type: HttpClient }
    ]; };
    /** @nocollapse */ ContactsService.ngInjectableDef = defineInjectable({ factory: function ContactsService_Factory() { return new ContactsService(inject(HttpClient)); }, token: ContactsService, providedIn: "root" });
    return ContactsService;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var ELEMENT_DATA = [
    { position: 1, name: 'Hydrogen', weight: 1.0079, symbol: 'H' },
    { position: 2, name: 'Helium', weight: 4.0026, symbol: 'He' },
    { position: 3, name: 'Lithium', weight: 6.941, symbol: 'Li' },
    { position: 4, name: 'Beryllium', weight: 9.0122, symbol: 'Be' },
    { position: 5, name: 'Boron', weight: 10.811, symbol: 'B' },
    { position: 6, name: 'Carbon', weight: 12.0107, symbol: 'C' },
    { position: 7, name: 'Nitrogen', weight: 14.0067, symbol: 'N' },
    { position: 8, name: 'Oxygen', weight: 15.9994, symbol: 'O' },
    { position: 9, name: 'Fluorine', weight: 18.9984, symbol: 'F' },
    { position: 10, name: 'Neon', weight: 20.1797, symbol: 'Ne' },
];
var AccountsComponent = /** @class */ (function () {
    function AccountsComponent(contactsService) {
        this.contactsService = contactsService;
        this.displayedColumns = ['position', 'name', 'weight', 'symbol'];
        this.dataSource = ELEMENT_DATA;
    }
    /**
     * @return {?}
     */
    AccountsComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this.subscribe();
    };
    /**
     * @protected
     * @return {?}
     */
    AccountsComponent.prototype.subscribe = /**
     * @protected
     * @return {?}
     */
    function () {
        var _this = this;
        this.subscription = this.contactsService.list().subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            _this.items = data;
            // this.dataSource.data = this.items;
            // console.log(JSON.stringify(this.items));
        }));
    };
    AccountsComponent.decorators = [
        { type: Component, args: [{
                    selector: 'sales-accounts',
                    template: "<h2 class=\"lib-component-title\"> {{ 'ACCOUNTS_HEADER' | translate }} </h2>\n\n<div class=\"table-container\">\n\n  <table mat-table [dataSource]=\"dataSource\" class=\"mat-elevation-z8\">\n\n    <ng-container matColumnDef=\"position\">\n      <th mat-header-cell *matHeaderCellDef> No. </th>\n      <td mat-cell *matCellDef=\"let element\"> {{element.position}} </td>\n    </ng-container>\n\n    <ng-container matColumnDef=\"name\">\n      <th mat-header-cell *matHeaderCellDef> Name </th>\n      <td mat-cell *matCellDef=\"let element\"> {{element.name}} </td>\n    </ng-container>\n\n    <ng-container matColumnDef=\"weight\">\n      <th mat-header-cell *matHeaderCellDef> Weight </th>\n      <td mat-cell *matCellDef=\"let element\"> {{element.weight}} </td>\n    </ng-container>\n\n    <ng-container matColumnDef=\"symbol\">\n      <th mat-header-cell *matHeaderCellDef> Symbol </th>\n      <td mat-cell *matCellDef=\"let element\"> {{element.symbol}} </td>\n    </ng-container>\n\n    <tr mat-header-row *matHeaderRowDef=\"displayedColumns; sticky: true\"></tr>\n    <tr mat-row *matRowDef=\"let row; columns: displayedColumns;\"></tr>\n\n  </table>\n\n</div>\n",
                    styles: [".table-container{height:400px;overflow:auto}table{width:100%}"]
                }] }
    ];
    /** @nocollapse */
    AccountsComponent.ctorParameters = function () { return [
        { type: ContactsService }
    ]; };
    return AccountsComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ActivitiesComponent = /** @class */ (function () {
    function ActivitiesComponent(logger) {
        this.logger = logger;
    }
    /**
     * @return {?}
     */
    ActivitiesComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this.logger.info('ActivitiesComponent: ngOnInit()');
    };
    /**
     * @return {?}
     */
    ActivitiesComponent.prototype.canDeactivate = /**
     * @return {?}
     */
    function () {
        this.logger.info('ActivitiesComponent: canDeactivate()');
        return true;
    };
    //
    // Command Bar events
    //
    //
    // Command Bar events
    //
    /**
     * @return {?}
     */
    ActivitiesComponent.prototype.onRefresh = 
    //
    // Command Bar events
    //
    /**
     * @return {?}
     */
    function () {
        this.taskList.refresh();
    };
    ActivitiesComponent.decorators = [
        { type: Component, args: [{
                    selector: 'sales-activities',
                    template: "<crm-command-bar>\n\n  <button mat-button class=\"crm-command-bar-button\" [disabled]=\"true\">\n    <mat-icon>add</mat-icon>\n    NEW\n  </button>\n\n  <button mat-button class=\"crm-command-bar-button\" (click)=\"onRefresh()\">\n    <mat-icon>refresh</mat-icon>\n    REFRESH\n  </button>\n\n</crm-command-bar>\n\n<div class=\"crm-component-title-container\">\n  <h1 class=\"crm-component-title\"> {{ 'ACTIVITIES_HEADER' | translate }} </h1>\n</div>\n\n<flow-task-list> </flow-task-list>\n\n<!--\n\n  <button mat-button class=\"crm-command-bar-button\" [disabled]=\"true\">\n\n-->\n",
                    styles: [""]
                }] }
    ];
    /** @nocollapse */
    ActivitiesComponent.ctorParameters = function () { return [
        { type: LoggerService }
    ]; };
    ActivitiesComponent.propDecorators = {
        taskList: [{ type: ViewChild, args: [TaskListComponent,] }]
    };
    return ActivitiesComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
// See: variables.scss
/*

// https://github.com/angular/material2/blob/master/src/lib/toolbar/toolbar.scss

$mat-toolbar-height-desktop: 64px !default;
$mat-toolbar-height-mobile: 56px !default;
$mat-toolbar-row-padding: 16px !default;

@media ($mat-xsmall) {
  @include mat-toolbar-height($mat-toolbar-height-mobile);
}

*/
/** @type {?} */
var MAT_XSMALL = '(max-width: 599px)';
/** @type {?} */
var FAKE_ITEMS_LENGTH = 16;
// export const TOOLBAR_HEIGHT_DESKTOP = 64;
// export const TOOLBAR_HEIGHT_MOBILE  = 56;
/** @type {?} */
var NAVIGATION_BAR_HEIGHT_DESKTOP = 64;
/** @type {?} */
var COMMAND_BAR_HEIGHT_DESKTOP = 56;
/** @type {?} */
var VIEW_BAR_HEIGHT_DESKTOP = 96;
/** @type {?} */
var MARGIN_DESKTOP = 32;
/** @type {?} */
var ALPHABET = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M',
    'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];
// displayedColumns = [ 'displayName', 'email', 'organisation.name', 'organisation.phoneNumber', 'id' ];
/** @type {?} */
var CONTACT_COLUMNS_DESKTOP = ['displayName', 'email', 'organisation.name', 'organisation.phoneNumber', 'id'];
/** @type {?} */
var CONTACT_COLUMNS_MOBILE = ['displayName', 'id'];

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
//
// No Annotations - see: https://medium.com/@ttemplier/angular2-decorators-and-class-inheritance-905921dbd1b7#.c60rva7jo
//
/**
 * @abstract
 */
var  
//
// No Annotations - see: https://medium.com/@ttemplier/angular2-decorators-and-class-inheritance-905921dbd1b7#.c60rva7jo
//
/**
 * @abstract
 */
CollectionComponent = /** @class */ (function () {
    function CollectionComponent() {
        this.fakeItems = new Array(FAKE_ITEMS_LENGTH);
        // https://stackoverflow.com/questions/48891174/angular-material-2-datatable-sorting-with-nested-objects
        this.getProperty = (/**
         * @param {?} obj
         * @param {?} path
         * @return {?}
         */
        function (obj, path) { return (path.split('.').reduce((/**
         * @param {?} o
         * @param {?} p
         * @return {?}
         */
        function (o, p) { return o && o[p]; }), obj)); });
        /** @type {?} */
        var injector = StaticInjectorService.getInjector();
        this.logger = injector.get((/** @type {?} */ (LoggerService)));
    }
    /**
     * @return {?}
     */
    CollectionComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this.logger.info('CollectionComponent: ngOnInit()');
        this.subscribe();
    };
    /**
     * @protected
     * @return {?}
     */
    CollectionComponent.prototype.subscribe = /**
     * @protected
     * @return {?}
     */
    function () {
        this.logger.info('CollectionComponent: subscribe()');
    };
    /**
     * @protected
     * @return {?}
     */
    CollectionComponent.prototype.unsubscribe = /**
     * @protected
     * @return {?}
     */
    function () {
        this.logger.info('CollectionComponent: unsubscribe()');
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    };
    /**
     * @return {?}
     */
    CollectionComponent.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        this.logger.info('CollectionComponent: ngOnDestroy()');
        this.unsubscribe();
    };
    return CollectionComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ContactsComponent = /** @class */ (function (_super) {
    __extends(ContactsComponent, _super);
    function ContactsComponent(router, breakpointObserver, contactsService, commandBarSidenavService) {
        var _this = _super.call(this) || this;
        _this.router = router;
        _this.breakpointObserver = breakpointObserver;
        _this.contactsService = contactsService;
        _this.commandBarSidenavService = commandBarSidenavService;
        _this.dataSource = null;
        _this.displayedColumns = [];
        _this.alphabet = ALPHABET;
        _this.columnDefs = [
            {
                name: 'displayName',
                displayName: 'FULL NAME',
                class: 'anchor'
            },
            {
                name: 'email',
                displayName: 'EMAIL',
                class: ''
            },
            {
                name: 'organisation.name',
                displayName: 'COMPANY NAME',
                class: 'anchor'
            },
            {
                name: 'organisation.phoneNumber',
                displayName: 'BUSINESS PHONE',
                class: ''
            }
        ];
        _this.selectedFooterItemId = 'All';
        return _this;
    }
    /**
     * @return {?}
     */
    ContactsComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        _super.prototype.ngOnInit.call(this);
        this.logger.info('ContactsPage: ngOnInit()');
        // Evaluate against the current viewport
        if (this.breakpointObserver.isMatched(MAT_XSMALL)) {
            this.displayedColumns = CONTACT_COLUMNS_MOBILE;
        }
        else {
            this.displayedColumns = CONTACT_COLUMNS_DESKTOP;
        }
    };
    // https://blog.angular-university.io/angular-debugging/
    // https://blog.angular-university.io/angular-debugging/
    /**
     * @return {?}
     */
    ContactsComponent.prototype.ngAfterViewInit = 
    // https://blog.angular-university.io/angular-debugging/
    /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.logger.info('ContactsPage: ngAfterViewInit()');
        // React to changes to the viewport
        this.breakpointObserver.observe([Breakpoints.HandsetPortrait]).subscribe((/**
         * @param {?} result
         * @return {?}
         */
        function (result) {
            if (result.matches) {
                _this.displayedColumns = CONTACT_COLUMNS_MOBILE;
            }
            else {
                _this.displayedColumns = CONTACT_COLUMNS_DESKTOP;
            }
        }));
    };
    // https://developer.mozilla.org/en-US/docs/Web/API/WindowBase64/Base64_encoding_and_decoding
    // https://developer.mozilla.org/en-US/docs/Web/API/WindowBase64/Base64_encoding_and_decoding
    /**
     * @protected
     * @return {?}
     */
    ContactsComponent.prototype.subscribe = 
    // https://developer.mozilla.org/en-US/docs/Web/API/WindowBase64/Base64_encoding_and_decoding
    /**
     * @protected
     * @return {?}
     */
    function () {
        var _this = this;
        this.logger.info('ContactsPage: subscribe()');
        this.subscription = this.contactsService.list().subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            data.map((/**
             * @param {?} a
             * @return {?}
             */
            function (a) {
                a.id = btoa(a.id);
                return __assign({}, a);
            }));
            _this.items = data;
            _this.dataSource = new MatTableDataSource(_this.items);
            _this.dataSource.data = _this.items;
            _this.dataSource.sortingDataAccessor = pathDataAccessor;
            _this.dataSource.sort = _this.sort;
        }));
    };
    /**
     * @return {?}
     */
    ContactsComponent.prototype.refresh = /**
     * @return {?}
     */
    function () {
        this.logger.info('ContactsPage: refresh()');
    };
    /**
     * @param {?} id
     * @return {?}
     */
    ContactsComponent.prototype.onClickFilterButton = /**
     * @param {?} id
     * @return {?}
     */
    function (id) {
        this.logger.info('ContactsPage: onClickFilterButton()');
        this.logger.info('Button Id: ' + id);
        this.selectedFooterItemId = id;
    };
    //
    // Command Bar events
    //
    //
    // Command Bar events
    //
    /**
     * @return {?}
     */
    ContactsComponent.prototype.onNew = 
    //
    // Command Bar events
    //
    /**
     * @return {?}
     */
    function () {
        this.logger.info('ContactsPage: onNew()');
        // btoa(0) === 'MA=='
        this.router.navigate(['sales/contacts/MA==']);
    };
    /**
     * @return {?}
     */
    ContactsComponent.prototype.onToggleSidenav = /**
     * @return {?}
     */
    function () {
        this.logger.info('ContactsPage: onToggleSidenav()');
        this.commandBarSidenavService.toggle();
    };
    ContactsComponent.decorators = [
        { type: Component, args: [{
                    selector: 'sales-contacts',
                    template: "<crm-command-bar>\n\n  <button mat-button class=\"crm-command-bar-button\" (click)=\"onNew()\">\n    <mat-icon>add</mat-icon>\n    NEW\n  </button>\n\n  <button mat-button class=\"crm-command-bar-button\" [disabled]=\"true\">\n    <mat-icon>visibility</mat-icon>\n    ACTIVATE\n  </button>\n\n  <button mat-button class=\"crm-command-bar-button\" [disabled]=\"true\">\n    <mat-icon>visibility_off</mat-icon>\n    DEACTIVATE\n  </button>\n\n  <button mat-button class=\"crm-command-bar-button\" [disabled]=\"true\">\n    <mat-icon>link</mat-icon>\n    EMAIL A LINK\n  </button>\n\n  <button mat-button class=\"crm-command-bar-button\" [disabled]=\"true\">\n    <mat-icon>description</mat-icon>\n    RUN REPORT\n  </button>\n\n</crm-command-bar>\n\n<div class=\"crm-component-title-container\">\n  <h1 class=\"crm-component-title\"> {{ 'CONTACTS_HEADER' | translate }} </h1>\n</div>\n\n<div #contentContainer class=\"crm-content-container\">\n\n  <ng-container *ngIf=\"!items; then skeleton\"> </ng-container>\n\n  <!-- <div *ngIf=\"items\" class=\"crm-table-container\"> -->\n  <div class=\"crm-table-container\">\n\n    <table mat-table\n           [hidden]=\"!items\"\n           [dataSource]=\"dataSource\"\n           matSort\n           matSortStart=\"desc\"\n           class=\"mat-elevation-z8 crm-table\">\n\n      <ng-container matColumnDef=\"id\">\n        <th mat-header-cell *matHeaderCellDef class=\"header-cell-id\">\n\n          <button mat-icon-button (click)=\"refresh()\">\n            <mat-icon matListIcon class=\"header-icon\">autorenew</mat-icon>\n          </button>\n\n        </th>\n        <td mat-cell *matCellDef=\"let element\"> </td>\n        <td mat-footer-cell *matFooterCellDef> </td>\n      </ng-container>\n\n      <ng-container *ngFor=\"let column of columnDefs\" [matColumnDef]=\"column.name\">\n        <th mat-header-cell *matHeaderCellDef mat-sort-header>\n          {{ column.displayName }}\n        </th>\n        <td mat-cell *matCellDef=\"let row\">\n\n          <ng-container *ngIf=\"column.class === 'anchor'\">\n            <a [routerLink]=\"[row.id]\">\n              {{ getProperty(row, column.name) }}\n            </a>\n          </ng-container>\n\n          <ng-container *ngIf=\"column.class !== 'anchor'\">\n            <a>\n              {{ getProperty(row, column.name) }}\n            </a>\n          </ng-container>\n\n        </td>\n      </ng-container>\n\n      <ng-container matColumnDef=\"footer\">\n        <td mat-footer-cell *matFooterCellDef colspan=\"5\">\n\n          <div class=\"footer-container\" fxHide.xs>\n\n            <button id=\"All\" mat-button class=\"footer-button\" (click)=\"onClickFilterButton('All')\"\n                    [class.active]=\"selectedFooterItemId === 'All'\">\n              All\n            </button>\n\n            <button mat-button disabled class=\"footer-button\" fxHide.xs>\n              |\n            </button>\n\n            <div *ngFor=\"let character of alphabet\" fxHide.xs>\n              <button id=\"{{ character }}\" mat-button class=\"footer-button\" (click)=\"onClickFilterButton(character)\"\n                      [class.active]=\"selectedFooterItemId === character\">\n                {{ character }}\n              </button>\n            </div>\n\n            <button mat-button disabled class=\"footer-button\" fxHide.xs>\n              |\n            </button>\n\n            <div>\n\n              <button mat-button class=\"footer-button-first-page\">\n                <mat-icon>skip_previous</mat-icon>\n              </button>\n\n              <button mat-button class=\"footer-button-previous-page\">\n                <mat-icon>keyboard_arrow_left</mat-icon>\n              </button>\n\n              <span class=\"footer-page-number\">\n                Page 1\n              </span>\n\n              <button mat-button class=\"footer-button-last-page\">\n                <mat-icon>keyboard_arrow_right</mat-icon>\n              </button>\n\n            </div>\n\n          </div>\n\n        </td>\n      </ng-container>\n\n      <tr mat-header-row *matHeaderRowDef=\"displayedColumns; sticky: true\"></tr>\n      <tr mat-row *matRowDef=\"let row; columns: displayedColumns;\"></tr>\n\n      <tr mat-footer-row *matFooterRowDef=\"['footer']; sticky: true\"></tr>\n\n    </table>\n\n  </div>\n\n  <!-- Skeleton template -->\n\n  <ng-template #skeleton>\n\n    <div class=\"crm-spinner-container\">\n      <mat-spinner color=\"accent\"></mat-spinner>\n    </div>\n\n  </ng-template>\n\n</div> <!-- contentContainer -->\n\n<!--\n\n<div #contentContainer class=\"crm-content-container\" (window:resize)=\"onResize($event)\">\n\n-->\n",
                    styles: [".header-toolbar{background:#fafafa}.header-title{font-weight:700;padding:0 16px 0 40px}.header-icon{margin:0 12px}.footer-container{display:flex;justify-content:space-between;white-space:nowrap}.footer-button{min-width:24px;padding:0 8px}.footer-button-first-page,.footer-button-last-page,.footer-button-next-page,.footer-button-previous-page{min-width:24px;padding:0}.footer-page-number{padding-top:14px;padding-left:8px;padding-right:8px}th.mat-header-cell{padding-right:16px;white-space:nowrap}.header-cell-id{text-align:right}td.mat-cell{padding-right:16px}.mat-cell{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.mat-column-displayName{width:280px;max-width:280px}.mat-column-email{width:260px;max-width:260px}.mat-column-organisation-name{width:200px;max-width:120px}.mat-column-organisation-phoneNumber{width:120px;max-width:120px}"]
                }] }
    ];
    /** @nocollapse */
    ContactsComponent.ctorParameters = function () { return [
        { type: Router },
        { type: BreakpointObserver },
        { type: ContactsService },
        { type: SidenavService }
    ]; };
    ContactsComponent.propDecorators = {
        sort: [{ type: ViewChild, args: [MatSort,] }]
    };
    return ContactsComponent;
}(CollectionComponent));
// https://stackoverflow.com/questions/48891174/angular-material-2-datatable-sorting-with-nested-objects
/**
 * @param {?} item
 * @param {?} path
 * @return {?}
 */
function pathDataAccessor(item, path) {
    return path.split('.')
        .reduce((/**
     * @param {?} accumulator
     * @param {?} key
     * @return {?}
     */
    function (accumulator, key) {
        return accumulator ? accumulator[key] : undefined;
    }), item);
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var GENERAL_INFORMATION_GROUP = 'general-information-form';
/** @type {?} */
var ADDRESS_INFORMATION_GROUP = 'address-information-form';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ContactComponent = /** @class */ (function () {
    function ContactComponent(route, router, contactsService, dynamicFormService, dialogService, snackBar, logger) {
        this.route = route;
        this.router = router;
        this.contactsService = contactsService;
        this.dynamicFormService = dynamicFormService;
        this.dialogService = dialogService;
        this.snackBar = snackBar;
        this.logger = logger;
        this.newContact = false;
        this.id = 'MA==';
        this.subscriptions = [];
        // DynamicFormControlModel[] = [];
        this.navBarHeight = NAVIGATION_BAR_HEIGHT_DESKTOP;
        this.cmdBarHeight = COMMAND_BAR_HEIGHT_DESKTOP;
        this.viewBarHeight = VIEW_BAR_HEIGHT_DESKTOP;
        this.margin = MARGIN_DESKTOP;
    }
    /**
     * @return {?}
     */
    ContactComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.logger.info('ContactComponent: ngOnInit()');
        this.containerHeight = this.tableContainer.nativeElement.offsetHeight -
            (this.navBarHeight + this.cmdBarHeight + this.viewBarHeight + this.margin);
        // this.id = this.route.snapshot.paramMap.get('id');
        /** @type {?} */
        var paramSubscription = new Subscription();
        this.subscriptions.push(paramSubscription);
        paramSubscription = this.route.paramMap.subscribe((/**
         * @param {?} params
         * @return {?}
         */
        function (params) {
            _this.id = params.get('id');
            _this.id = atob(_this.id);
            if (_this.id === '0') {
                _this.newContact = true;
            }
            _this.subscribe();
        }));
    };
    /**
     * @protected
     * @return {?}
     */
    ContactComponent.prototype.subscribe = /**
     * @protected
     * @return {?}
     */
    function () {
        var _this = this;
        this.logger.info('ContactComponent: subscribe()');
        /** @type {?} */
        var formSubscription = new Subscription();
        this.subscriptions.push(formSubscription);
        // General Information
        formSubscription = this.dynamicFormService.getFormMetadata(GENERAL_INFORMATION_GROUP).pipe(tap((/**
         * @return {?}
         */
        function () {
            if (!_this.newContact) {
                /** @type {?} */
                var modelSubscription = new Subscription();
                _this.subscriptions.push(modelSubscription);
                modelSubscription = _this.contactsService.get(_this.id).subscribe((/**
                 * @param {?} data
                 * @return {?}
                 */
                function (data) {
                    _this.item = data;
                    _this.dynamicFormService.initGroup(_this.generalInformationGroup, _this.item);
                    _this.dynamicFormService.initGroup(_this.addressInformationGroup, _this.item);
                }));
            }
        }))).subscribe((/**
         * @param {?} metaData
         * @return {?}
         */
        function (metaData) {
            _this.generalInformationModel = metaData;
            _this.generalInformationGroup = _this.dynamicFormService.createGroup(_this.generalInformationModel);
        }));
        // Address Information
        formSubscription = new Subscription();
        this.subscriptions.push(formSubscription);
        formSubscription = this.dynamicFormService.getFormMetadata(ADDRESS_INFORMATION_GROUP).pipe(tap((/**
         * @return {?}
         */
        function () {
            if (_this.newContact) {
                _this.logger.info('ContactComponent: subscribe() - this.item = {} as Contact');
                _this.item = (/** @type {?} */ ({}));
            }
            /*
      
            let modelSubscription: Subscription = new Subscription();
            this.subscriptions.push(modelSubscription);
      
            modelSubscription = this.contactsService.get(this.id).subscribe(data => {
              this.item = data;
              this.dynamicFormService.initGroup(this.addressInformationGroup, this.item);
            });
      
            */
            /*
      
            if (this.item) {
              this.dynamicFormService.initGroup(this.addressInformationGroup, this.item);
            }
      
            */
        }))).subscribe((/**
         * @param {?} metaData
         * @return {?}
         */
        function (metaData) {
            _this.addressInformationModel = metaData;
            _this.addressInformationGroup = _this.dynamicFormService.createGroup(_this.addressInformationModel);
        }));
    };
    /**
     * @protected
     * @return {?}
     */
    ContactComponent.prototype.unsubscribe = /**
     * @protected
     * @return {?}
     */
    function () {
        this.logger.info('ContactComponent: unsubscribe()');
        this.subscriptions.forEach((/**
         * @param {?} subscription
         * @return {?}
         */
        function (subscription) {
            subscription.unsubscribe();
        }));
    };
    /**
     * @return {?}
     */
    ContactComponent.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        this.logger.info('ContactComponent: ngOnDestroy()');
        this.unsubscribe();
    };
    //
    // Misc
    //
    //
    // Misc
    //
    /**
     * @return {?}
     */
    ContactComponent.prototype.isValid = 
    //
    // Misc
    //
    /**
     * @return {?}
     */
    function () {
        // this.logger.info('ContactComponent - isValid()');
        // this.logger.info('ContactComponent - isValid()');
        /** @type {?} */
        var valid = false;
        if (this.generalInformationGroup && this.generalInformationGroup.valid) {
            if (this.addressInformationGroup && this.addressInformationGroup.valid) {
                valid = true;
                // this.logger.info('valid: ' + valid);
            }
        }
        return valid;
    };
    //
    // Command Bar events
    //
    //
    // Command Bar events
    //
    /**
     * @return {?}
     */
    ContactComponent.prototype.onNew = 
    //
    // Command Bar events
    //
    /**
     * @return {?}
     */
    function () {
        this.logger.info('ContactPage: onNew()');
        // btoa(0) === 'MA=='
        this.router.navigate(['sales/contacts/MA==']);
    };
    /**
     * @return {?}
     */
    ContactComponent.prototype.onSave = /**
     * @return {?}
     */
    function () {
        this.logger.info('ContactPage: onSave()');
        /*
    
        this.snackBar.open('Contact saved', '', {
          duration: 2000,
          panelClass: ['crm-snack-bar']
        });
    
        */
        this.openSnackBar();
    };
    /**
     * @return {?}
     */
    ContactComponent.prototype.onSaveAndClose = /**
     * @return {?}
     */
    function () {
        this.logger.info('ContactPage: onSaveAndClose()');
        this.router.navigate(['sales/contacts']);
    };
    /**
     * @param {?} event
     * @return {?}
     */
    ContactComponent.prototype.onCustomEvent = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        this.logger.info('ContactPage: onCustomEvent()');
        this.dialogService.openAlert({
            title: 'Alert',
            message: JSON.stringify(event),
            closeButton: 'CLOSE'
        });
        // this.logger.info('event: ' + JSON.stringify(event));
    };
    /**
     * @private
     * @return {?}
     */
    ContactComponent.prototype.openSnackBar = /**
     * @private
     * @return {?}
     */
    function () {
        this.snackBar.openFromComponent(SnackBarComponent, {
            duration: 500,
            panelClass: 'crm-snack-bar'
        });
    };
    ContactComponent.decorators = [
        { type: Component, args: [{
                    selector: 'sales-contact',
                    template: "<crm-command-bar>\n\n  <ng-container *ngIf=\"newContact\">\n\n    <button mat-button class=\"crm-command-bar-button\"\n            [disabled]=\"!isValid()\"\n            (click)=\"onSave()\">\n      <mat-icon>save</mat-icon>\n      SAVE\n    </button>\n\n    <button mat-button class=\"crm-command-bar-button\"\n            [disabled]=\"!isValid()\"\n            (click)=\"onSaveAndClose()\">\n      <mat-icon>arrow_back</mat-icon>\n      SAVE & CLOSE\n    </button>\n\n  </ng-container>\n\n  <ng-container *ngIf=\"!newContact\">\n\n    <button mat-button class=\"crm-command-bar-button\" (click)=\"onNew()\">\n      <mat-icon>add</mat-icon>\n      NEW\n    </button>\n\n    <button mat-button class=\"crm-command-bar-button\" [disabled]=\"true\">\n      <mat-icon>visibility</mat-icon>\n      ACTIVATE\n    </button>\n\n    <button mat-button class=\"crm-command-bar-button\" [disabled]=\"true\">\n      <mat-icon>visibility_off</mat-icon>\n      DEACTIVATE\n    </button>\n\n    <button mat-button class=\"crm-command-bar-button\" [disabled]=\"true\">\n      <mat-icon>link</mat-icon>\n      EMAIL A LINK\n    </button>\n\n  </ng-container>\n\n  <div fxFlex fxLayout fxLayoutAlign=\"flex-end\">\n\n    <button mat-button class=\"crm-command-bar-button\" [disabled]=\"true\">\n      <mat-icon>open_in_new</mat-icon>\n    </button>\n\n    <button mat-button class=\"crm-command-bar-button\" [disabled]=\"true\">\n      <mat-icon>clear</mat-icon>\n    </button>\n\n  </div>\n\n</crm-command-bar>\n\n<div class=\"crm-component-title-container\">\n  <h1 class=\"crm-component-title\"> {{ 'CONTACT_HEADER' | translate }} </h1>\n</div>\n\n<div #contentContainer class=\"crm-content-container\">\n\n  <ng-container *ngIf=\"!item; then skeleton\"> </ng-container>\n\n  <ng-container *ngIf=\"item\">\n\n    <div #gridContainer class=\"crm-grid-container\">\n\n      <mat-card>\n\n        <mat-card-header>\n          <mat-card-title>\n            General Information\n          </mat-card-title>\n        </mat-card-header>\n\n        <mat-card-content>\n\n          <!-- Chrome ignores autocomplete=\"off\" so go to chrome://settings/autofill and turn 'Auto-fill forms' off -->\n\n          <dynamic-form autocomplete=\"off\"\n                        [className]=\"'crm-nested-grid-container'\"\n                        [formGroup]=\"generalInformationGroup\"\n                        [model]=\"generalInformationModel\"\n                        (customEvent)=\"onCustomEvent($event)\">\n          </dynamic-form>\n\n          <!--\n          <p>\n            Form Value: {{ generalInformationGroup.value | json }}\n          </p>\n          -->\n\n        </mat-card-content>\n\n      </mat-card>\n\n      <mat-card>\n\n        <mat-card-header>\n          <mat-card-title>\n            Address Information\n          </mat-card-title>\n        </mat-card-header>\n\n        <mat-card-content>\n\n          <!-- Chrome ignores autocomplete=\"off\" so go to chrome://settings/autofill and turn 'Auto-fill forms' off -->\n\n          <dynamic-form autocomplete=\"off\"\n                        [className]=\"'crm-nested-grid-container'\"\n                        [formGroup]=\"addressInformationGroup\"\n                        [model]=\"addressInformationModel\">\n          </dynamic-form>\n\n          <!--\n          <p>\n            Form Value: {{ addressInformationGroup.value | json }}\n          </p>\n          -->\n\n        </mat-card-content>\n\n      </mat-card>\n\n    </div>\n\n  </ng-container> <!-- gridContainer -->\n\n  <!-- Skeleton template -->\n\n  <ng-template #skeleton>\n    <div class=\"crm-spinner-container\" [style.height.px]=\"containerHeight\">\n      <mat-spinner color=\"accent\"></mat-spinner>\n    </div>\n  </ng-template>\n\n</div> <!-- contentContainer -->\n\n<!--\n\n (dynamicEvent)=\"onEvent($event)\">\n\n-->\n",
                    styles: [".mat-card{padding:0}.mat-card-header{background:rgba(0,0,0,.04);padding-top:8px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.mat-card-content{padding:16px}"]
                }] }
    ];
    /** @nocollapse */
    ContactComponent.ctorParameters = function () { return [
        { type: ActivatedRoute },
        { type: Router },
        { type: ContactsService },
        { type: DynamicFormService },
        { type: DialogService },
        { type: MatSnackBar },
        { type: LoggerService }
    ]; };
    ContactComponent.propDecorators = {
        tableContainer: [{ type: ViewChild, args: ['contentContainer',] }]
    };
    return ContactComponent;
}());
var SnackBarComponent = /** @class */ (function () {
    function SnackBarComponent() {
    }
    SnackBarComponent.decorators = [
        { type: Component, args: [{
                    selector: 'sales-toast',
                    template: "\n    <span>\n      Contact saved\n    </span>\n  "
                }] }
    ];
    return SnackBarComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var DashboardComponent = /** @class */ (function () {
    function DashboardComponent(commandBarSidenavService, dashboardService, dashboardWidgetService, logger) {
        this.commandBarSidenavService = commandBarSidenavService;
        this.dashboardService = dashboardService;
        this.dashboardWidgetService = dashboardWidgetService;
        this.logger = logger;
        this.dashboardId = '1';
        this.dashboardName = 'Sample Dashboard 1';
        this.screenFull = (/** @type {?} */ (screenfull));
    }
    /**
     * @return {?}
     */
    DashboardComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.logger.info('Sales DashboardComponent: ngOnInit()');
        if (this.screenFull.enabled) {
            this.logger.info('DashboardComponent: Screenfull change handler registered');
            this.screenFull.on('change', (/**
             * @return {?}
             */
            function () {
                if (_this.screenFull.isFullscreen) {
                    _this.logger.info('Am I fullscreen? Yes');
                }
                else {
                    _this.logger.info('Am I fullscreen? No');
                }
                window.dispatchEvent(new Event('resize'));
                setTimeout((/**
                 * @return {?}
                 */
                function () {
                    _this.dashboardWidgetService.reflowWidgets();
                }), 750);
            }));
        }
        this.subscribe();
    };
    /**
     * @protected
     * @return {?}
     */
    DashboardComponent.prototype.subscribe = /**
     * @protected
     * @return {?}
     */
    function () {
        var _this = this;
        this.logger.info('Sales DashboardComponent: subscribe()');
        this.subscription = this.dashboardService.getDashboards().subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            _this.items = data;
            _this.logger.info('Dashboards: ' + JSON.stringify(_this.items));
        }));
    };
    /**
     * @protected
     * @return {?}
     */
    DashboardComponent.prototype.unsubscribe = /**
     * @protected
     * @return {?}
     */
    function () {
        this.logger.info('Sales DashboardComponent: unsubscribe()');
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    };
    /**
     * @return {?}
     */
    DashboardComponent.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        this.logger.info('Sales DashboardComponent: ngOnDestroy()');
        this.unsubscribe();
    };
    //
    // Command Bar events
    //
    //
    // Command Bar events
    //
    /**
     * @return {?}
     */
    DashboardComponent.prototype.onToggleSidenav = 
    //
    // Command Bar events
    //
    /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.logger.info('Sales DashboardComponent: onToggleSidenav()');
        this.commandBarSidenavService.toggle().then((/**
         * @return {?}
         */
        function () {
            if (_this.commandBarSidenavService.isOpen()) {
                _this.logger.info('commandBarSidenav is open');
            }
            else {
                _this.logger.info('commandBarSidenav is closed');
            }
            // this.gridster.resize();
            window.dispatchEvent(new Event('resize'));
            setTimeout((/**
             * @return {?}
             */
            function () {
                _this.dashboardWidgetService.reflowWidgets();
            }), 500);
        }));
    };
    /*
    public onToggleSidenav() {
  
      this.logger.info('Sales DashboardComponent: onToggleSidenav()');
  
      this.commandBarSidenavService.toggle();
  
      if (this.commandBarSidenavService.isOpen()) {
        this.logger.info('commandBarSidenav is open');
      } else {
        this.logger.info('commandBarSidenav is closed');
      }
  
      window.dispatchEvent(new Event('resize'));
    }
    */
    /*
      public onToggleSidenav() {
    
        this.logger.info('Sales DashboardComponent: onToggleSidenav()');
    
        this.commandBarSidenavService.toggle();
    
        if (this.commandBarSidenavService.isOpen()) {
          this.logger.info('commandBarSidenav is open');
        } else {
          this.logger.info('commandBarSidenav is closed');
        }
    
        window.dispatchEvent(new Event('resize'));
      }
      */
    /**
     * @return {?}
     */
    DashboardComponent.prototype.onFullscreen = /*
      public onToggleSidenav() {
    
        this.logger.info('Sales DashboardComponent: onToggleSidenav()');
    
        this.commandBarSidenavService.toggle();
    
        if (this.commandBarSidenavService.isOpen()) {
          this.logger.info('commandBarSidenav is open');
        } else {
          this.logger.info('commandBarSidenav is closed');
        }
    
        window.dispatchEvent(new Event('resize'));
      }
      */
    /**
     * @return {?}
     */
    function () {
        this.logger.info('Sales DashboardComponent: onFullscreen()');
        if (this.screenFull.enabled) {
            this.screenFull.toggle();
        }
    };
    //
    // Activity Bar events
    //
    //
    // Activity Bar events
    //
    /**
     * @param {?} item
     * @return {?}
     */
    DashboardComponent.prototype.onMenuClick = 
    //
    // Activity Bar events
    //
    /**
     * @param {?} item
     * @return {?}
     */
    function (item) {
        this.logger.info('Sales DashboardComponent: onMenuClick()');
        this.dashboardId = item.id;
        this.dashboardName = item.name;
        this.logger.info('Dashboard Id: ' + this.dashboardId);
    };
    DashboardComponent.decorators = [
        { type: Component, args: [{
                    selector: 'sales-dashboard',
                    template: "<crm-command-bar>\n\n  <button mat-button class=\"crm-command-bar-button\" [disabled]=\"true\">\n    <mat-icon>save</mat-icon>\n    SAVE AS\n  </button>\n\n  <button mat-button class=\"crm-command-bar-button\" [disabled]=\"true\">\n    <mat-icon>dashboard</mat-icon>\n    NEW\n  </button>\n\n  <button mat-button class=\"crm-command-bar-button\" [disabled]=\"true\">\n    <mat-icon>lock</mat-icon>\n    SET AS DEFAULT\n  </button>\n\n  <button mat-button class=\"crm-command-bar-button\" [disabled]=\"true\">\n    <mat-icon>refresh</mat-icon>\n    REFRESH\n  </button>\n\n  <div fxFlex fxLayout fxLayoutAlign=\"flex-end\">\n\n    <button mat-button class=\"crm-command-bar-button\" (click)=\"onToggleSidenav()\">\n      <mat-icon>widgets</mat-icon>\n      WIDGETS\n    </button>\n\n    <button mat-button class=\"crm-command-bar-button\" (click)=\"onFullscreen()\">\n      <mat-icon>fullscreen</mat-icon>\n      FULL SCREEN\n    </button>\n\n  </div>\n\n</crm-command-bar>\n\n<crm-activity-bar>\n\n  {{dashboardName}}\n\n  <button mat-button [matMenuTriggerFor]=\"dashboardMenu\" class=\"crm-activity-bar-menu-button\">\n    <mat-icon>arrow_drop_down</mat-icon>\n  </button>\n\n  <mat-menu #dashboardMenu=\"matMenu\">\n\n    <button *ngFor=\"let item of items\" mat-menu-item (click)=\"onMenuClick(item)\">\n      <mat-icon>dashboard</mat-icon>\n      <span>{{item.name}}</span>\n    </button>\n\n  </mat-menu>\n\n</crm-activity-bar>\n\n<div class=\"crm-dashboard-container\">\n\n  <dashboard [dashboardId]=\"dashboardId\"></dashboard>\n\n</div>\n\n<!--\n\n<div class=\"crm-component-title-container\">\n\n  <h1 class=\"crm-component-title\"> {{ 'SALES_ACTIVITY_DASHBOARD_HEADER' | translate }} </h1>\n\n</div>\n\n-->\n",
                    styles: [""]
                }] }
    ];
    /** @nocollapse */
    DashboardComponent.ctorParameters = function () { return [
        { type: SidenavService },
        { type: MockDashboardService },
        { type: DashboardWidgetService },
        { type: LoggerService }
    ]; };
    return DashboardComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
// tslint:enable:no-unused-variable
var InMemoryDataService = /** @class */ (function () {
    function InMemoryDataService() {
    }
    /**
     * @param {?=} reqInfo
     * @return {?}
     */
    InMemoryDataService.prototype.createDb = /**
     * @param {?=} reqInfo
     * @return {?}
     */
    function (reqInfo) {
        /* tslint:disable */
        /* tslint:disable */
        /** @type {?} */
        var contacts = [
            {
                "id": "1",
                "displayName": "Abetz, Senator the Hon Eric",
                "title": "Senator the Hon",
                "givenName": "Eric",
                "middleName": "",
                "familyName": "Abetz",
                "honorific": "",
                "salutation": "Senator",
                "preferredName": "Eric",
                "initials": "E.",
                "gender": "MALE",
                "email": "eric.abetz@aph.gov.au",
                "phoneNumber": "",
                "photoUrl": "",
                "organisation": {
                    "id": "",
                    "name": "Liberal Party",
                    "phoneNumber": "(03) 6224 3707"
                },
                "address": {
                    "id": "1",
                    "line1": "Highbury House",
                    "line2": "136 Davey Street",
                    "city": "Hobart",
                    "state": "TAS",
                    "postalCode": "7001"
                }
            },
            {
                "id": "2",
                "displayName": "Anning, Senator Fraser",
                "title": "Senator",
                "givenName": "Fraser",
                "middleName": "",
                "familyName": "Anning",
                "honorific": "",
                "salutation": "Senator",
                "preferredName": "Fraser",
                "initials": "F.",
                "gender": "MALE",
                "email": "fraser.anning@aph.gov.au",
                "phoneNumber": "",
                "photoUrl": "",
                "organisation": {
                    "id": "",
                    "name": "Katter's Australian Party",
                    "phoneNumber": "(07) 3221 9099"
                },
                "address": {
                    "id": "2",
                    "line1": "Suite 2, Level 36, Waterfront Place",
                    "line2": "1 Eagle Street",
                    "city": "Brisbane",
                    "state": "QLD",
                    "postalCode": "5067"
                }
            },
            {
                "id": "3",
                "displayName": "Bernardi, Senator Cory",
                "title": "Senator",
                "givenName": "Cory",
                "middleName": "",
                "familyName": "Bernardi",
                "honorific": "",
                "salutation": "Senator",
                "preferredName": "Cory",
                "initials": "C.",
                "gender": "MALE",
                "email": "cory.bernardi@aph.gov.au",
                "phoneNumber": "",
                "photoUrl": "",
                "organisation": {
                    "id": "3",
                    "name": "Australian Conservatives",
                    "phoneNumber": "(08) 8362 8600"
                }
            },
            { "id": "4", "displayName": "Bilyk, Senator Catryna", "title": "Senator", "givenName": "Catryna", "middleName": "", "familyName": "Bilyk", "honorific": "", "salutation": "Senator", "preferredName": "Catryna", "initials": "C. L.", "gender": "FEMALE", "email": "catryna.bilyk@aph.gov.au", "phoneNumber": "", "photoUrl": "", "organisation": { "id": "", "name": "Labor Party", "phoneNumber": "(03) 6229 4444" } },
            { "id": "5", "displayName": "Birmingham, Senator the Hon Simon", "title": "Senator the Hon", "givenName": "Simon", "middleName": "", "familyName": "Birmingham", "honorific": "", "salutation": "Senator", "preferredName": "Simon", "initials": "S. J.", "gender": "MALE", "email": "simon.birmingham@aph.gov.au", "phoneNumber": "", "photoUrl": "", "organisation": { "id": "", "name": "Liberal Party", "phoneNumber": "(08) 8354 1644" } },
            { "id": "6", "displayName": "Brockman, Senator Slade", "title": "Senator", "givenName": "Slade", "middleName": "", "familyName": "Brockman", "honorific": "", "salutation": "Senator", "preferredName": "Slade", "initials": "S.", "gender": "MALE", "email": "slade.brockman@aph.gov.au", "phoneNumber": "", "photoUrl": "", "organisation": { "id": "", "name": "Liberal Party", "phoneNumber": "(08) 9414 7288" } },
            { "id": "7", "displayName": "Brown, Senator Carol", "title": "Senator", "givenName": "Carol", "middleName": "", "familyName": "Brown", "honorific": "", "salutation": "Senator", "preferredName": "Carol", "initials": "C. L.", "gender": "FEMALE", "email": "carol.brown@aph.gov.au", "phoneNumber": "", "photoUrl": "", "organisation": { "id": "", "name": "Labor Party", "phoneNumber": "(03) 6231 0099" } },
            { "id": "8", "displayName": "Burston, Senator Brian", "title": "Senator", "givenName": "Brian", "middleName": "", "familyName": "Burston", "honorific": "", "salutation": "Senator", "preferredName": "Brian", "initials": "B.", "gender": "MALE", "email": "brian.burston@aph.gov.au", "phoneNumber": "", "photoUrl": "", "organisation": { "id": "", "name": "United Australia Party", "phoneNumber": "(02) 4959 1044" } },
            { "id": "9", "displayName": "Bushby, Senator David", "title": "Senator", "givenName": "David", "middleName": "", "familyName": "Bushby", "honorific": "", "salutation": "Senator", "preferredName": "David", "initials": "D. C", "gender": "MALE", "email": "david.bushby@aph.gov.au", "phoneNumber": "", "photoUrl": "", "organisation": { "id": "", "name": "Liberal Party", "phoneNumber": "(03) 6331 8501" } },
            { "id": "10", "displayName": "Cameron, Senator the Hon Douglas", "title": "Senator the Hon", "givenName": "Douglas", "middleName": "", "familyName": "Cameron", "honorific": "", "salutation": "Senator", "preferredName": "Doug", "initials": "D. N.", "gender": "MALE", "email": "douglas.cameron@aph.gov.au", "phoneNumber": "", "photoUrl": "", "organisation": { "id": "", "name": "Labor Party", "phoneNumber": "(02) 4751 4288" } },
            { "id": "11", "displayName": "Canavan, Senator the Hon Matthew", "title": "Senator the Hon", "givenName": "Matthew", "middleName": "", "familyName": "Canavan", "honorific": "", "salutation": "Senator", "preferredName": "Matthew", "initials": "M.J.", "gender": "MALE", "email": "matthew.canavan@aph.gov.au", "phoneNumber": "", "photoUrl": "", "organisation": { "id": "", "name": "National Party", "phoneNumber": "(07) 4927 2003" } },
            { "id": "12", "displayName": "Carr, Senator the Hon Kim", "title": "Senator the Hon", "givenName": "Kim", "middleName": "", "familyName": "Carr", "honorific": "", "salutation": "Senator", "preferredName": "Kim", "initials": "K. J.", "gender": "MALE", "email": "kim.carr@aph.gov.au", "phoneNumber": "", "photoUrl": "", "organisation": { "id": "", "name": "Labor Party", "phoneNumber": "(03) 9639 2798" } },
            { "id": "13", "displayName": "Cash, Senator the Hon Michaelia", "title": "Senator the Hon", "givenName": "Michaelia", "middleName": "", "familyName": "Cash", "honorific": "", "salutation": "Senator", "preferredName": "Michaelia", "initials": "M.C.", "gender": "FEMALE", "email": "michaelia.cash@aph.gov.au", "phoneNumber": "", "photoUrl": "", "organisation": { "id": "", "name": "Liberal Party", "phoneNumber": "(08) 9226 2000" } },
            { "id": "14", "displayName": "Chisholm, Senator Anthony", "title": "Senator", "givenName": "Anthony", "middleName": "", "familyName": "Chisholm", "honorific": "", "salutation": "Senator", "preferredName": "Anthony", "initials": "A.", "gender": "MALE", "email": "anthony.chisholm@aph.gov.au", "phoneNumber": "", "photoUrl": "", "organisation": { "id": "", "name": "Labor Party", "phoneNumber": "(07) 3229 4477" } },
            { "id": "15", "displayName": "Colbeck, Senator the Hon Richard", "title": "Senator the Hon", "givenName": "Richard", "middleName": "", "familyName": "Colbeck", "honorific": "", "salutation": "Senator", "preferredName": "Richard", "initials": "R.M.", "gender": "MALE", "email": "richard.colbeck@aph.gov.au", "phoneNumber": "", "photoUrl": "", "organisation": { "id": "", "name": "Liberal Party", "phoneNumber": "(03) 6424 5960" } },
            { "id": "16", "displayName": "Collins, Senator the Hon Jacinta", "title": "Senator the Hon", "givenName": "Jacinta", "middleName": "", "familyName": "Collins", "honorific": "", "salutation": "Senator", "preferredName": "Jacinta", "initials": "J. M. A.", "gender": "FEMALE", "email": "jacinta.collins@aph.gov.au", "phoneNumber": "", "photoUrl": "", "organisation": { "id": "", "name": "Labor Party", "phoneNumber": "(03) 9890 7022" } },
            { "id": "17", "displayName": "Cormann, Senator the Hon Mathias", "title": "Senator the Hon", "givenName": "Mathias", "middleName": "", "familyName": "Cormann", "honorific": "", "salutation": "Senator", "preferredName": "Mathias", "initials": "M.H.P.", "gender": "MALE", "email": "mathias.cormann@aph.gov.au", "phoneNumber": "", "photoUrl": "", "organisation": { "id": "", "name": "Liberal Party", "phoneNumber": "(08) 9325 4227" } },
            { "id": "18", "displayName": "Di Natale, Senator Richard", "title": "Senator", "givenName": "Richard", "middleName": "", "familyName": "Di Natale", "honorific": "", "salutation": "Senator", "preferredName": "Richard", "initials": "R.", "gender": "MALE", "email": "richard.di natale@aph.gov.au", "phoneNumber": "", "photoUrl": "", "organisation": { "id": "", "name": "Australian Greens", "phoneNumber": "(03) 9654 0430" } },
            { "id": "19", "displayName": "Dodson, Senator Patrick", "title": "Senator", "givenName": "Patrick", "middleName": "", "familyName": "Dodson", "honorific": "", "salutation": "Senator", "preferredName": "Patrick", "initials": "P.", "gender": "MALE", "email": "patrick.dodson@aph.gov.au", "phoneNumber": "", "photoUrl": "", "organisation": { "id": "", "name": "Labor Party", "phoneNumber": "(08) 9193 5955" } },
            { "id": "20", "displayName": "Duniam, Senator Jonathon", "title": "Senator", "givenName": "Jonathon", "middleName": "", "familyName": "Duniam", "honorific": "", "salutation": "Senator", "preferredName": "Jonathon", "initials": "J.R.", "gender": "MALE", "email": "jonathon.duniam@aph.gov.au", "phoneNumber": "", "photoUrl": "", "organisation": { "id": "", "name": "Liberal Party", "phoneNumber": "(03) 6231 2444" } },
            { "id": "21", "displayName": "Farrell, Senator the Hon Donald", "title": "Senator the Hon", "givenName": "Donald", "middleName": "", "familyName": "Farrell", "honorific": "", "salutation": "Senator", "preferredName": "Don", "initials": "D. E.", "gender": "MALE", "email": "donald.farrell@aph.gov.au", "phoneNumber": "", "photoUrl": "", "organisation": { "id": "", "name": "Labor Party", "phoneNumber": "(08)  8231 8400" } },
            { "id": "22", "displayName": "Faruqi, Senator Mehreen", "title": "Senator", "givenName": "Mehreen", "middleName": "", "familyName": "Faruqi", "honorific": "", "salutation": "Senator", "preferredName": "Mehreen", "initials": "M.", "gender": "FEMALE", "email": "mehreen.faruqi@aph.gov.au", "phoneNumber": "", "photoUrl": "", "organisation": { "id": "", "name": "Australian Greens", "phoneNumber": "(02) 9211 1500" } },
            { "id": "23", "displayName": "Fawcett, Senator the Hon David", "title": "Senator the Hon", "givenName": "David", "middleName": "", "familyName": "Fawcett", "honorific": "", "salutation": "Senator", "preferredName": "David", "initials": "D.J.", "gender": "MALE", "email": "david.fawcett@aph.gov.au", "phoneNumber": "", "photoUrl": "", "organisation": { "id": "", "name": "Liberal Party", "phoneNumber": "(08) 8205 1040" } },
            { "id": "24", "displayName": "Fierravanti-Wells, Senator the Hon Concetta", "title": "Senator the Hon", "givenName": "Concetta", "middleName": "", "familyName": "Fierravanti-Wells", "honorific": "", "salutation": "Senator", "preferredName": "Concetta", "initials": "C.", "gender": "FEMALE", "email": "concetta.fierravanti-wells@aph.gov.au", "phoneNumber": "", "photoUrl": "", "organisation": { "id": "", "name": "Liberal Party", "phoneNumber": "(02) 4226 1700" } },
            { "id": "25", "displayName": "Fifield, Senator the Hon Mitchell", "title": "Senator the Hon", "givenName": "Mitchell", "middleName": "", "familyName": "Fifield", "honorific": "", "salutation": "Senator", "preferredName": "Mitch", "initials": "M. P.", "gender": "MALE", "email": "mitchell.fifield@aph.gov.au", "phoneNumber": "", "photoUrl": "", "organisation": { "id": "", "name": "Liberal Party", "phoneNumber": "(03) 9584 2455" } },
            { "id": "26", "displayName": "Gallacher, Senator Alexander", "title": "Senator", "givenName": "Alexander", "middleName": "", "familyName": "Gallacher", "honorific": "", "salutation": "Senator", "preferredName": "Alex", "initials": "A. M.", "gender": "MALE", "email": "alexander.gallacher@aph.gov.au", "phoneNumber": "", "photoUrl": "", "organisation": { "id": "", "name": "Labor Party", "phoneNumber": "(08) 8269 6022" } },
            { "id": "27", "displayName": "Georgiou, Senator Peter", "title": "Senator", "givenName": "Peter", "middleName": "", "familyName": "Georgiou", "honorific": "", "salutation": "Senator", "preferredName": "Peter", "initials": "P.", "gender": "MALE", "email": "peter.georgiou@aph.gov.au", "phoneNumber": "", "photoUrl": "", "organisation": { "id": "", "name": "One Nation", "phoneNumber": "(08) 9226 1750" } },
            { "id": "28", "displayName": "Gichuhi, Senator Lucy", "title": "Senator", "givenName": "Lucy", "middleName": "", "familyName": "Gichuhi", "honorific": "", "salutation": "Senator", "preferredName": "Lucy", "initials": "L.M.", "gender": "FEMALE", "email": "lucy.gichuhi@aph.gov.au", "phoneNumber": "", "photoUrl": "", "organisation": { "id": "", "name": "Liberal Party", "phoneNumber": "(08) 8205 1050" } },
            { "id": "29", "displayName": "Griff, Senator Stirling", "title": "Senator", "givenName": "Stirling", "middleName": "", "familyName": "Griff", "honorific": "", "salutation": "Senator", "preferredName": "Stirling", "initials": "S.", "gender": "MALE", "email": "stirling.griff@aph.gov.au", "phoneNumber": "", "photoUrl": "", "organisation": { "id": "", "name": "Centre Alliance", "phoneNumber": "(08) 8212 1409" } },
            { "id": "30", "displayName": "Hanson, Senator Pauline", "title": "Senator", "givenName": "Pauline", "middleName": "", "familyName": "Hanson", "honorific": "", "salutation": "Senator", "preferredName": "Pauline", "initials": "P.L.", "gender": "FEMALE", "email": "pauline.hanson@aph.gov.au", "phoneNumber": "", "photoUrl": "", "organisation": { "id": "", "name": "One Nation", "phoneNumber": "(07) 3221 7644" } },
            { "id": "31", "displayName": "Hanson-Young, Senator Sarah", "title": "Senator", "givenName": "Sarah", "middleName": "", "familyName": "Hanson-Young", "honorific": "", "salutation": "Senator", "preferredName": "Sarah", "initials": "S.C.", "gender": "FEMALE", "email": "sarah.hanson-young@aph.gov.au", "phoneNumber": "", "photoUrl": "", "organisation": { "id": "", "name": "Australian Greens", "phoneNumber": "(08) 8227 0425" } },
            { "id": "32", "displayName": "Hinch, Senator Derryn", "title": "Senator", "givenName": "Derryn", "middleName": "", "familyName": "Hinch", "honorific": "", "salutation": "Senator", "preferredName": "Derryn", "initials": "D.N.", "gender": "MALE", "email": "derryn.hinch@aph.gov.au", "phoneNumber": "", "photoUrl": "", "organisation": { "id": "", "name": "Justice Party", "phoneNumber": "(03) 9820 2222" } },
            { "id": "33", "displayName": "Hume, Senator Jane", "title": "Senator", "givenName": "Jane", "middleName": "", "familyName": "Hume", "honorific": "", "salutation": "Senator", "preferredName": "Jane", "initials": "J.", "gender": "FEMALE", "email": "jane.hume@aph.gov.au", "phoneNumber": "", "photoUrl": "", "organisation": { "id": "", "name": "Liberal Party", "phoneNumber": "(03) 9232 8820" } },
            { "id": "34", "displayName": "Keneally, Senator the Hon Kristina", "title": "Senator the Hon", "givenName": "Kristina", "middleName": "", "familyName": "Keneally", "honorific": "", "salutation": "Senator", "preferredName": "Kristina", "initials": "K.K.", "gender": "FEMALE", "email": "kristina.keneally@aph.gov.au", "phoneNumber": "", "photoUrl": "", "organisation": { "id": "", "name": "Labor Party", "phoneNumber": "02) 9891 9139" } },
            { "id": "35", "displayName": "Ketter, Senator Christopher", "title": "Senator", "givenName": "Christopher", "middleName": "", "familyName": "Ketter", "honorific": "", "salutation": "Senator", "preferredName": "Chris", "initials": "C.R.", "gender": "MALE", "email": "christopher.ketter@aph.gov.au", "phoneNumber": "", "photoUrl": "", "organisation": { "id": "", "name": "Labor Party", "phoneNumber": "(07) 3881 3710" } },
            { "id": "36", "displayName": "Kitching, Senator Kimberley", "title": "Senator", "givenName": "Kimberley", "middleName": "", "familyName": "Kitching", "honorific": "", "salutation": "Senator", "preferredName": "Kimberley", "initials": "K.", "gender": "FEMALE", "email": "kimberley.kitching@aph.gov.au", "phoneNumber": "", "photoUrl": "", "organisation": { "id": "", "name": "Labor Party", "phoneNumber": "(03) 9374 1640" } },
            { "id": "37", "displayName": "Leyonhjelm, Senator David", "title": "Senator", "givenName": "David", "middleName": "", "familyName": "Leyonhjelm", "honorific": "", "salutation": "Senator", "preferredName": "David", "initials": "D.E.", "gender": "MALE", "email": "david.leyonhjelm@aph.gov.au", "phoneNumber": "", "photoUrl": "", "organisation": { "id": "", "name": "Liberal Democratic Party", "phoneNumber": "(02) 9719 1078" } },
            { "id": "38", "displayName": "Lines, Senator Susan", "title": "Senator", "givenName": "Susan", "middleName": "", "familyName": "Lines", "honorific": "", "salutation": "Senator", "preferredName": "Sue", "initials": "S.", "gender": "FEMALE", "email": "susan.lines@aph.gov.au", "phoneNumber": "", "photoUrl": "", "organisation": { "id": "", "name": "Labor Party", "phoneNumber": "(08) 9481 4844" } },
            { "id": "39", "displayName": "Macdonald, Senator the Hon Ian", "title": "Senator the Hon", "givenName": "Ian", "middleName": "", "familyName": "Macdonald", "honorific": "", "salutation": "Senator", "preferredName": "Ian", "initials": "I. D.", "gender": "MALE", "email": "ian.macdonald@aph.gov.au", "phoneNumber": "", "photoUrl": "", "organisation": { "id": "", "name": "Liberal Party", "phoneNumber": "(07) 4771 3066" } },
            { "id": "40", "displayName": "Marshall, Senator Gavin", "title": "Senator", "givenName": "Gavin", "middleName": "", "familyName": "Marshall", "honorific": "", "salutation": "Senator", "preferredName": "Gavin", "initials": "G. M.", "gender": "MALE", "email": "gavin.marshall@aph.gov.au", "phoneNumber": "", "photoUrl": "", "organisation": { "id": "", "name": "Labor Party", "phoneNumber": "(03) 9348 9699" } },
            { "id": "41", "displayName": "Martin, Senator Steven", "title": "Senator", "givenName": "Steven", "middleName": "", "familyName": "Martin", "honorific": "", "salutation": "Senator", "preferredName": "Steve", "initials": "S.L.", "gender": "MALE", "email": "steven.martin@aph.gov.au", "phoneNumber": "", "photoUrl": "", "organisation": { "id": "", "name": "National Party", "phoneNumber": "(03) 6420 7560" } },
            { "id": "42", "displayName": "McAllister, Senator Jennifer", "title": "Senator", "givenName": "Jennifer", "middleName": "", "familyName": "McAllister", "honorific": "", "salutation": "Senator", "preferredName": "Jenny", "initials": "J.R.", "gender": "FEMALE", "email": "jennifer.mcallister@aph.gov.au", "phoneNumber": "", "photoUrl": "", "organisation": { "id": "", "name": "Labor Party", "phoneNumber": "(02) 9719 8100" } },
            { "id": "43", "displayName": "McCarthy, Senator Malarndirri", "title": "Senator", "givenName": "Malarndirri", "middleName": "", "familyName": "McCarthy", "honorific": "", "salutation": "Senator", "preferredName": "Malarndirri", "initials": "M.", "gender": "FEMALE", "email": "malarndirri.mccarthy@aph.gov.au", "phoneNumber": "", "photoUrl": "", "organisation": { "id": "", "name": "Labor Party", "phoneNumber": "(08) 8941 0003" } },
            { "id": "44", "displayName": "McGrath, Senator the Hon James", "title": "Senator the Hon", "givenName": "James", "middleName": "", "familyName": "McGrath", "honorific": "", "salutation": "Senator", "preferredName": "James", "initials": "J.", "gender": "MALE", "email": "james.mcgrath@aph.gov.au", "phoneNumber": "", "photoUrl": "", "organisation": { "id": "", "name": "Liberal Party", "phoneNumber": "(07) 5441 1800" } },
            { "id": "45", "displayName": "McKenzie, Senator the Hon Bridget", "title": "Senator the Hon", "givenName": "Bridget", "middleName": "", "familyName": "McKenzie", "honorific": "", "salutation": "Senator", "preferredName": "Bridget", "initials": "B.", "gender": "FEMALE", "email": "bridget.mckenzie@aph.gov.au", "phoneNumber": "", "photoUrl": "", "organisation": { "id": "", "name": "National Party", "phoneNumber": "(03) 5441 4251" } },
            { "id": "46", "displayName": "McKim, Senator Nicholas", "title": "Senator", "givenName": "Nicholas", "middleName": "", "familyName": "McKim", "honorific": "", "salutation": "Senator", "preferredName": "Nick", "initials": "N.J.", "gender": "MALE", "email": "nicholas.mckim@aph.gov.au", "phoneNumber": "", "photoUrl": "", "organisation": { "id": "", "name": "Australian Greens", "phoneNumber": "(03) 6224 8899" } },
            { "id": "47", "displayName": "Molan, Senator Andrew", "title": "Senator", "givenName": "Andrew", "middleName": "", "familyName": "Molan", "honorific": "AO, DSC", "salutation": "Senator", "preferredName": "Jim", "initials": "A.J.", "gender": "MALE", "email": "andrew.molan@aph.gov.au", "phoneNumber": "", "photoUrl": "", "organisation": { "id": "", "name": "Liberal Party", "phoneNumber": "(02) 6284 3115" } },
            { "id": "48", "displayName": "Moore, Senator Claire", "title": "Senator", "givenName": "Claire", "middleName": "", "familyName": "Moore", "honorific": "", "salutation": "Senator", "preferredName": "Claire", "initials": "C. M.", "gender": "FEMALE", "email": "claire.moore@aph.gov.au", "phoneNumber": "", "photoUrl": "", "organisation": { "id": "", "name": "Labor Party", "phoneNumber": "(07) 3252 7101" } },
            { "id": "49", "displayName": "O'Neill, Senator Deborah", "title": "Senator", "givenName": "Deborah", "middleName": "", "familyName": "O'Neill", "honorific": "", "salutation": "Senator", "preferredName": "Deborah", "initials": "D.", "gender": "FEMALE", "email": "deborah.o'neill@aph.gov.au", "phoneNumber": "", "photoUrl": "", "organisation": { "id": "", "name": "Labor Party", "phoneNumber": "(02) 4367 4565" } },
            { "id": "50", "displayName": "O'Sullivan, Senator Barry", "title": "Senator", "givenName": "Barry", "middleName": "", "familyName": "O'Sullivan", "honorific": "", "salutation": "Senator", "preferredName": "Barry", "initials": "B. J.", "gender": "MALE", "email": "barry.o'sullivan@aph.gov.au", "phoneNumber": "", "photoUrl": "", "organisation": { "id": "", "name": "National Party", "phoneNumber": "(07) 4638 7555" } },
            { "id": "51", "displayName": "Paterson, Senator James", "title": "Senator", "givenName": "James", "middleName": "", "familyName": "Paterson", "honorific": "", "salutation": "Senator", "preferredName": "James", "initials": "J.", "gender": "MALE", "email": "james.paterson@aph.gov.au", "phoneNumber": "", "photoUrl": "", "organisation": { "id": "", "name": "Liberal Party", "phoneNumber": "(03) 9690 2201" } },
            { "id": "52", "displayName": "Patrick, Senator Rex", "title": "Senator", "givenName": "Rex", "middleName": "", "familyName": "Patrick", "honorific": "", "salutation": "Senator", "preferredName": "Rex", "initials": "R.L.", "gender": "MALE", "email": "rex.patrick@aph.gov.au", "phoneNumber": "", "photoUrl": "", "organisation": { "id": "", "name": "Centre Alliance", "phoneNumber": "(08) 8232 1144" } },
            { "id": "53", "displayName": "Payne, Senator the Hon Marise", "title": "Senator the Hon", "givenName": "Marise", "middleName": "", "familyName": "Payne", "honorific": "", "salutation": "Senator", "preferredName": "Marise", "initials": "M. A.", "gender": "FEMALE", "email": "marise.payne@aph.gov.au", "phoneNumber": "", "photoUrl": "", "organisation": { "id": "", "name": "Liberal Party", "phoneNumber": "(02) 9687 8755" } },
            { "id": "54", "displayName": "Polley, Senator Helen", "title": "Senator", "givenName": "Helen", "middleName": "", "familyName": "Polley", "honorific": "", "salutation": "Senator", "preferredName": "Helen", "initials": "H.", "gender": "FEMALE", "email": "helen.polley@aph.gov.au", "phoneNumber": "", "photoUrl": "", "organisation": { "id": "", "name": "Labor Party", "phoneNumber": "(03) 6331 2599" } },
            { "id": "55", "displayName": "Pratt, Senator Louise", "title": "Senator", "givenName": "Louise", "middleName": "", "familyName": "Pratt", "honorific": "", "salutation": "Senator", "preferredName": "Louise", "initials": "L.C.", "gender": "FEMALE", "email": "louise.pratt@aph.gov.au", "phoneNumber": "", "photoUrl": "", "organisation": { "id": "", "name": "Labor Party", "phoneNumber": "(08) 9277 1502" } },
            { "id": "56", "displayName": "Reynolds, Senator the Hon Linda", "title": "Senator the Hon", "givenName": "Linda", "middleName": "", "familyName": "Reynolds", "honorific": "CSC", "salutation": "Senator", "preferredName": "Linda", "initials": "L.K.", "gender": "FEMALE", "email": "linda.reynolds@aph.gov.au", "phoneNumber": "", "photoUrl": "", "organisation": { "id": "", "name": "Liberal Party", "phoneNumber": "(08) 9477 5411" } },
            { "id": "57", "displayName": "Rice, Senator Janet", "title": "Senator", "givenName": "Janet", "middleName": "", "familyName": "Rice", "honorific": "", "salutation": "Senator", "preferredName": "Janet", "initials": "J.E.", "gender": "FEMALE", "email": "janet.rice@aph.gov.au", "phoneNumber": "", "photoUrl": "", "organisation": { "id": "", "name": "Australian Greens", "phoneNumber": "(03) 9384 6199" } },
            { "id": "58", "displayName": "Ruston, Senator the Hon Anne", "title": "Senator the Hon", "givenName": "Anne", "middleName": "", "familyName": "Ruston", "honorific": "", "salutation": "Senator", "preferredName": "Anne", "initials": "A.", "gender": "FEMALE", "email": "anne.ruston@aph.gov.au", "phoneNumber": "", "photoUrl": "", "organisation": { "id": "", "name": "Liberal Party", "phoneNumber": "(08) 8586 6600" } },
            { "id": "59", "displayName": "Ryan, Senator the Hon Scott", "title": "Senator the Hon", "givenName": "Scott", "middleName": "", "familyName": "Ryan", "honorific": "", "salutation": "Senator", "preferredName": "Scott", "initials": "S.M.", "gender": "MALE", "email": "scott.ryan@aph.gov.au", "phoneNumber": "", "photoUrl": "", "organisation": { "id": "", "name": "Liberal Party", "phoneNumber": "(03) 9326 1088" } },
            { "id": "60", "displayName": "Scullion, Senator the Hon Nigel", "title": "Senator the Hon", "givenName": "Nigel", "middleName": "", "familyName": "Scullion", "honorific": "", "salutation": "Senator", "preferredName": "Nigel", "initials": "N. G.", "gender": "MALE", "email": "nigel.scullion@aph.gov.au", "phoneNumber": "", "photoUrl": "", "organisation": { "id": "", "name": "Liberal Party", "phoneNumber": "(08) 8948 3555" } },
            { "id": "61", "displayName": "Seselja, Senator the Hon Zdenko", "title": "Senator the Hon", "givenName": "Zdenko", "middleName": "", "familyName": "Seselja", "honorific": "", "salutation": "Senator", "preferredName": "Zed", "initials": "Z. M.", "gender": "MALE", "email": "zdenko.seselja@aph.gov.au", "phoneNumber": "", "photoUrl": "", "organisation": { "id": "", "name": "Liberal Party", "phoneNumber": "(02) 6247 6444" } },
            { "id": "62", "displayName": "Siewert, Senator Rachel", "title": "Senator", "givenName": "Rachel", "middleName": "", "familyName": "Siewert", "honorific": "", "salutation": "Senator", "preferredName": "Rachel", "initials": "R.", "gender": "FEMALE", "email": "rachel.siewert@aph.gov.au", "phoneNumber": "", "photoUrl": "", "organisation": { "id": "", "name": "Australian Greens", "phoneNumber": "(08) 9228 3277" } },
            { "id": "63", "displayName": "Singh, Senator the Hon Lisa", "title": "Senator the Hon", "givenName": "Lisa", "middleName": "", "familyName": "Singh", "honorific": "", "salutation": "Senator", "preferredName": "Lisa", "initials": "L. M.", "gender": "FEMALE", "email": "lisa.singh@aph.gov.au", "phoneNumber": "", "photoUrl": "", "organisation": { "id": "", "name": "Labor Party", "phoneNumber": "(03) 6223 1135" } },
            { "id": "64", "displayName": "Sinodinos, Senator the Hon Arthur", "title": "Senator the Hon", "givenName": "Arthur", "middleName": "", "familyName": "Sinodinos", "honorific": "AO", "salutation": "Senator", "preferredName": "Arthur", "initials": "A", "gender": "MALE", "email": "arthur.sinodinos@aph.gov.au", "phoneNumber": "", "photoUrl": "", "organisation": { "id": "", "name": "Liberal Party", "phoneNumber": "(02) 8289 9450" } },
            { "id": "65", "displayName": "Smith, Senator David", "title": "Senator", "givenName": "David", "middleName": "", "familyName": "Smith", "honorific": "", "salutation": "Senator", "preferredName": "David", "initials": "David", "gender": "MALE", "email": "david.smith@aph.gov.au", "phoneNumber": "", "photoUrl": "", "organisation": { "id": "", "name": "Labor Party", "phoneNumber": "(02) 6230 0411" } },
            { "id": "66", "displayName": "Smith, Senator Dean", "title": "Senator", "givenName": "Dean", "middleName": "", "familyName": "Smith", "honorific": "", "salutation": "Senator", "preferredName": "Dean", "initials": "D. A.", "gender": "MALE", "email": "dean.smith@aph.gov.au", "phoneNumber": "", "photoUrl": "", "organisation": { "id": "", "name": "Liberal Party", "phoneNumber": "(08) 9481 0349" } },
            { "id": "67", "displayName": "Steele-John, Senator Jordon", "title": "Senator", "givenName": "Jordon", "middleName": "", "familyName": "Steele-John", "honorific": "", "salutation": "Senator", "preferredName": "Jordon", "initials": "J.", "gender": "MALE", "email": "jordon.steele-john@aph.gov.au", "phoneNumber": "", "photoUrl": "", "organisation": { "id": "", "name": "Australian Greens", "phoneNumber": "(08) 6245 3310" } },
            { "id": "68", "displayName": "Sterle, Senator Glenn", "title": "Senator", "givenName": "Glenn", "middleName": "", "familyName": "Sterle", "honorific": "", "salutation": "Senator", "preferredName": "Glenn", "initials": "G.", "gender": "MALE", "email": "glenn.sterle@aph.gov.au", "phoneNumber": "", "photoUrl": "", "organisation": { "id": "", "name": "Labor Party", "phoneNumber": "(08) 9455 1420" } },
            { "id": "69", "displayName": "Stoker, Senator Amanda", "title": "Senator", "givenName": "Amanda", "middleName": "", "familyName": "Stoker", "honorific": "", "salutation": "Senator", "preferredName": "Amanda", "initials": "A.J.", "gender": "FEMALE", "email": "amanda.stoker@aph.gov.au", "phoneNumber": "", "photoUrl": "", "organisation": { "id": "", "name": "Liberal Party", "phoneNumber": "(07) 3001 8170" } },
            { "id": "70", "displayName": "Storer, Senator Timothy", "title": "Senator", "givenName": "Timothy", "middleName": "", "familyName": "Storer", "honorific": "", "salutation": "Senator", "preferredName": "Tim", "initials": "T.R.", "gender": "MALE", "email": "timothy.storer@aph.gov.au", "phoneNumber": "", "photoUrl": "", "organisation": { "id": "", "name": "Independent", "phoneNumber": "(08) 8282 0220" } },
            { "id": "71", "displayName": "Urquhart, Senator Anne", "title": "Senator", "givenName": "Anne", "middleName": "", "familyName": "Urquhart", "honorific": "", "salutation": "Senator", "preferredName": "Anne", "initials": "A. E.", "gender": "FEMALE", "email": "anne.urquhart@aph.gov.au", "phoneNumber": "", "photoUrl": "", "organisation": { "id": "", "name": "Labor Party", "phoneNumber": "(03) 6423 1933" } },
            { "id": "72", "displayName": "Waters, Senator Larissa", "title": "Senator", "givenName": "Larissa", "middleName": "", "familyName": "Waters", "honorific": "", "salutation": "Senator", "preferredName": "Larissa", "initials": "L.J.", "gender": "FEMALE", "email": "larissa.waters@aph.gov.au", "phoneNumber": "", "photoUrl": "", "organisation": { "id": "", "name": "Australian Greens", "phoneNumber": "(07) 3367 0566" } },
            { "id": "73", "displayName": "Watt, Senator Murray", "title": "Senator", "givenName": "Murray", "middleName": "", "familyName": "Watt", "honorific": "", "salutation": "Senator", "preferredName": "Murray", "initials": "M.P.", "gender": "MALE", "email": "murray.watt@aph.gov.au", "phoneNumber": "", "photoUrl": "", "organisation": { "id": "", "name": "Labor Party", "phoneNumber": "(07) 5531 1033" } },
            { "id": "74", "displayName": "Whish-Wilson, Senator Peter", "title": "Senator", "givenName": "Peter", "middleName": "", "familyName": "Whish-Wilson", "honorific": "", "salutation": "Senator", "preferredName": "Peter", "initials": "P. S.", "gender": "MALE", "email": "peter.whish-wilson@aph.gov.au", "phoneNumber": "", "photoUrl": "", "organisation": { "id": "", "name": "Australian Greens", "phoneNumber": "(03) 6331 0033" } },
            { "id": "75", "displayName": "Williams, Senator John", "title": "Senator", "givenName": "John", "middleName": "", "familyName": "Williams", "honorific": "", "salutation": "Senator", "preferredName": "John", "initials": "J. R.", "gender": "MALE", "email": "john.williams@aph.gov.au", "phoneNumber": "", "photoUrl": "", "organisation": { "id": "", "name": "National Party", "phoneNumber": "(02) 6721 4500" } },
            { "id": "76", "displayName": "Wong, Senator the Hon Penny", "title": "Senator the Hon", "givenName": "Penny", "middleName": "", "familyName": "Wong", "honorific": "", "salutation": "Senator", "preferredName": "Penny", "initials": "P.", "gender": "FEMALE", "email": "penny.wong@aph.gov.au", "phoneNumber": "", "photoUrl": "", "organisation": { "id": "", "name": "Labor Party", "phoneNumber": "(08) 8212 8272" } }
        ];
        // default returnType
        /** @type {?} */
        var returnType = 'object';
        // let returnType  = 'observable';
        // let returnType  = 'promise';
        // demonstrate POST commands/resetDb
        // this example clears the collections if the request body tells it to do so
        if (reqInfo) {
            /** @type {?} */
            var body = reqInfo.utils.getJsonBody(reqInfo.req) || {};
            if (body.clear === true) {
                contacts.length = 0;
                // nobodies.length = 0;
                // stringers.length = 0;
            }
            // 'returnType` can be 'object' | 'observable' | 'promise'
            returnType = body.returnType || 'object';
        }
        /** @type {?} */
        var db = { contacts: contacts };
        switch (returnType) {
            case ('observable'):
                return of(db).pipe(delay(10));
            case ('promise'):
                return new Promise((/**
                 * @param {?} resolve
                 * @return {?}
                 */
                function (resolve) {
                    setTimeout((/**
                     * @return {?}
                     */
                    function () { return resolve(db); }), 10);
                }));
            default:
                return db;
        }
    };
    InMemoryDataService.decorators = [
        { type: Injectable }
    ];
    return InMemoryDataService;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var routes = [
    {
        path: 'sales/activities',
        component: ActivitiesComponent,
        canActivate: [AuthGuard]
    },
    {
        path: 'sales/dashboards',
        component: DashboardComponent,
        canActivate: [AuthGuard]
    },
    //
    // The Wildcard route
    // See: app-routing.module.ts
    //
    {
        path: 'sales/contacts',
        component: ContactsComponent,
        canActivate: [AuthGuard],
        runGuardsAndResolvers: 'always'
    },
    {
        path: 'sales/contacts/:id',
        component: ContactComponent,
        canActivate: [AuthGuard]
    }
];
var LibRoutingModule = /** @class */ (function () {
    function LibRoutingModule() {
    }
    LibRoutingModule.decorators = [
        { type: NgModule, args: [{
                    imports: [RouterModule.forChild(routes)],
                    exports: [RouterModule]
                },] }
    ];
    return LibRoutingModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var SalesModule = /** @class */ (function () {
    function SalesModule(injector, logger) {
        this.injector = injector;
        this.logger = logger;
        this.logger.info('Sales Module initialised');
        StaticInjectorService.setInjector(injector);
    }
    SalesModule.decorators = [
        { type: NgModule, args: [{
                    imports: [
                        AngularMaterialModule,
                        CommonModule,
                        DashboardModule,
                        FlexLayoutModule,
                        FlowableModule,
                        // HttpClientModule,
                        ReactiveFormsModule,
                        HttpClientInMemoryWebApiModule.forFeature(InMemoryDataService, { passThruUnknownUrl: true, delay: 1000 }),
                        TranslateModule.forChild(),
                        UtilsModule,
                        SerendipityComponentsModule,
                        DynamicFormsModule,
                        LibRoutingModule // https://angular.io/guide/router#routing-module-order
                    ],
                    declarations: [
                        AccountsComponent,
                        ActivitiesComponent,
                        ContactsComponent,
                        ContactComponent,
                        DashboardComponent,
                        SnackBarComponent
                    ],
                    providers: [
                        { provide: LoggerService, useClass: ConsoleLoggerService }
                    ],
                    exports: [
                        AccountsComponent,
                        ActivitiesComponent,
                        ContactsComponent,
                        ContactComponent,
                        DashboardComponent
                        // SnackBarComponent
                    ],
                    entryComponents: [SnackBarComponent]
                },] }
    ];
    /** @nocollapse */
    SalesModule.ctorParameters = function () { return [
        { type: Injector },
        { type: LoggerService }
    ]; };
    return SalesModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { AccountsComponent, ActivitiesComponent, ContactComponent, ContactsComponent, DashboardComponent, SalesModule, SnackBarComponent, ContactsService as ɵa, CollectionComponent as ɵb, InMemoryDataService as ɵc, LibRoutingModule as ɵd };
//# sourceMappingURL=sales.js.map
